import React from "react";
import { useEffect, useState } from "react";
import { Row, Col, Table, Button } from "react-bootstrap";
import Modal from "react-awesome-modal";
import "./etablissement.css";
import QRCodeTicket from "../assets/QRCodeTicket";
import QRCodecarte from "../assets/QRCodeCarte";
import Moment from "react-moment";

function Etablissement() {
  const [etablissement, setEtablissement] = useState([]);
  const [indexEmploye, setIndexEmploye] = useState(0);
  const [show, setShow] = useState(false);
  const [modal, setModal] = useState(false);
  const [modalCarte, setModalCarte] = useState(false);
  const handleClose = () => setShow(false);
  const handleCloseCarte = () => setModalCarte(false);
  const handleCloseModal = () => setModal(false);
  const getEtablissement = () => {
    const headers = new Headers({
      "Content-Type": "application/json",
      "X-Requested-With": "XMLHttpRequest",
    });

    const options = {
      method: "GET",
      headers: headers,
    };

    fetch(
      "https://back-end.osc-fr1.scalingo.io/backOffice/getEtablissement",
      options
    )
      .then((response) => {
        return response.json();
      })
      .then(
        (responseObject) => {
          const monProfil = responseObject;
          console.log("profil", monProfil);
          setEtablissement(monProfil);
        },

        (error) => {
          console.log(error);
        }
      );
  };

  useEffect(() => {
    getEtablissement();
  }, []);
  useEffect(() => {}, [indexEmploye]);

  const renderEtablissement = () => {
    return etablissement.map((item, index) => {
      console.log("item", item.menu.dailyMenu.picture);
      return (
        <tr key={index}>
          <td>
            {" "}
            <Moment format="DD/MM/YYYY">{item?.inscriptionDate}</Moment>
          </td>
          <td>{item.restaurantName}</td>
          <td>{item.email}</td>
          <td>
            {item.tabServeur.length}
            <button
              onClick={() => {
                setIndexEmploye(index);
                setShow(true);
              }}
            >
              Voir +
            </button>{" "}
          </td>
          {item.referent === undefined ? (
            <td>Pas de référent</td>
          ) : (
            <td>
              {item.referent?.name}
              <br />
              {item.referent?.email}
            </td>
          )}
          <td>
            {item.menu.dailyMenu.picture == "" ? null : (
              <button
                onClick={() => {
                  setIndexEmploye(index);
                  setModal(true);
                }}
              >
                TICKET
              </button>
            )}

            <button
              onClick={() => {
                setIndexEmploye(index);
                setModalCarte(true);
              }}
            >
              CARTE
            </button>
          </td>
        </tr>
      );
    });
  };

  return (
    <div className="etabl">
      <Modal
        visible={modal}
        width="300"
        height="600"
        effect="fadeInUp"
        onClickAway={handleCloseModal}
      >
        <div className="affiPop">
          <h1>QR CODE TICKET</h1>
          <p> {etablissement[indexEmploye]?.restaurantName}</p>

          {modal ? (
            <QRCodeTicket
              etablissement={etablissement[indexEmploye]?.restaurantName}
            />
          ) : null}
        </div>
      </Modal>
      <Modal
        visible={modalCarte}
        width="300"
        height="600"
        effect="fadeInUp"
        onClickAway={handleCloseCarte}
      >
        <div className="affiPop">
          <h1>QR CODE CARTE</h1>
          <p> {etablissement[indexEmploye]?.restaurantName}</p>

          {modalCarte ? (
            <QRCodecarte
              etablissement={etablissement[indexEmploye]?.restaurantName}
            />
          ) : null}
        </div>
      </Modal>
      <Modal
        visible={show}
        width="600"
        height="500"
        effect="fadeInUp"
        onClickAway={handleClose}
      >
        <div className="affiPop">
          <h1>Liste des employés</h1>
          {etablissement[indexEmploye]?.tabServeur.map((element) => {
            return (
              <p>
                {element.serveurName}
                {""} {element.serveurLastName} {""}/ {element.serveurMail}
              </p>
            );
          })}
        </div>
      </Modal>

      <Row>
        <Col>
          <h2>Vision d'ensemble établissement</h2>
        </Col>
      </Row>
      <div className="rowBox">
        <Row className="element">
          <Col className="tableCol" md={12}>
            <Table striped bordered hover>
              <th>Date d'inscription</th>
              <th>Etablissement</th>
              <th>mail</th>
              <th>Nbre d'employés</th>
              <th>Référent désigné</th>
              <th>QR CODE</th>
              <tbody>{renderEtablissement()}</tbody>
            </Table>
          </Col>
        </Row>
      </div>
    </div>
  );
}
export default Etablissement;
